<template>
    <component
        v-bind:is="modalComponent"
        v-bind="$props"
        :classes="classes"
        :transition="transition"
        :content-classes="contentClasses"
        @before-open="$emit('before-open', $event)"
        @opened="$emit('opened', $event)"
        @before-close="$emit('before-close', $event)"
        @closed="$emit('closed', $event)"
    >
        <slot></slot>
    </component>
</template>

<script>
    export default {
        computed: {
            usesRightPanelModal() {
                return this.useRightPanelOnSmallScreens && this.$screen.isBreakpointOrLess(this.modalBreakpoint);
            },
            modalComponent() {
                return this.usesRightPanelModal
                    ? 'v-spa-right-panel-modal'
                    : 'v-spa-modal';
            },
            classes() {
                return this.usesRightPanelModal
                    ? this.rightPanelClasses
                    : this.defaultClasses;
            },
            contentClasses() {
                return this.usesRightPanelModal
                    ? this.rightPanelContentClasses
                    : this.defaultContentClasses;
            },
            transition() {
                return this.usesRightPanelModal
                    ? this.rightPanelTransition
                    : this.defaultTransition;
            }
        },
        props: {
            useRightPanelOnSmallScreens: {
                type: Boolean,
                default: true
            },
            name: {
                required: true,
                type: String,
            },
            height: {
                required: false,
            },
            scrollable: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                }
            },
            reset: {
                required: false,
                default() {
                    return true;
                }
            },
            width: {
                required: false,
                default() {
                    return 600;
                }
            },
            showCloseIcon: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                },
            },
            shiftX: {
                required: false,
                type: Number,
                default() {
                    return .5;
                },
            },
            shiftY: {
                required: false,
                type: Number,
                default() {
                    return .5;
                },
            },
            modalBreakpoint: {
                type: String,
                default: 'md'
            },
            defaultClasses: {
                required: false,
                type: String
            },
            rightPanelClasses: {
                required: false,
                type: String
            },
            defaultTransition: {
                required: false,
                type: String
            },
            rightPanelTransition: {
                required: false,
                type: String
            },
            defaultContentClasses: {
                required: false,
                type: String,
                default() {
                    return this.$spa.css.modal.content;
                }
            },
            rightPanelContentClasses: {
                required: false,
                type: String,
                default() {
                    return this.$spa.css.modal.right_panel.content;
                }
            },
            rightPanelWidth: {
                type: String,
                default: '700px'
            },
            rightPanelWidthXl: {
                type: String,
                default: '850px'
            }
        }
    }
</script>
